'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function last(arr) {
    return arr[arr.length - 1];
}

exports.last = last;
